<div class="alert-box">
    <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="onClose()">
            <span aria-hidden="true">&times;</span>
        </button>
        @if (!isOnboardingWizard) {
            <h4 class="modal-title">{{ "cta_after_publish_modal_title" | translate }}</h4>
        }
    </div>

    <div class="modal-body">
        @if (isOnboardingWizard) {
            <div class="text-center mb-20" style="margin-top: -32px">
                <img src="./assets/img/websites/lpc-onboarding-finished-img.svg" />
            </div>
            <h4 class="modal-title text-center mb-20">{{ "cta_after_publish_modal_title" | translate }}</h4>
        }
        <div class="input-group site-url-wrapper">
            <div
                class="form-control"
                [tooltip]="copiedTooltip"
                triggers="click:mouseleave"
                [cdkCopyToClipboard]="pageUrl"
            >
                <span class="text-dotted-crop text-nowrap">{{ pageUrl }}</span>
                <span class="sp-icon icon-copy color-light"> </span>
            </div>
            <div class="input-group-btn">
                <a class="btn btn-primary" type="button" [href]="pageUrl" target="_blank">Open website</a>
            </div>
        </div>

        <ng-template #copiedTooltip>
            {{ "copied_tooltip" | translate }}
        </ng-template>

        @if (showPaidAlert) {
            <div class="alert alert-paid mb-0 mt-20">
                {{ "get_pro_tariff_alert_text" | translate }}
                <a href="https://login.sendpulse.com/landing-pages/plans" target="_blank"
                    >{{ "get_pro_tariff_link" | translate }}
                    <span class="sp-icon icon-outgoing small-xs color-light"></span
                ></a>
            </div>
        }

        <div class="alert alert-info mb-0 mt-20">
            <label>{{ "learn_more_about_builder_label" | translate }}</label>

            <ul class="constructor-help-list">
                <li>
                    <a target="_blank" [href]="'partners_catalog_kb_link' | translate">
                        {{ "partners_catalog_kb_text" | translate }}
                        <i class="sp-icon icon-outgoing small-xs color-light"> </i>
                    </a>
                </li>
                <li>
                    <a target="_blank" [href]="'partners_catalog_kb_link_2' | translate">
                        {{ "partners_catalog_kb_text_2" | translate }}
                        <i class="sp-icon icon-outgoing small-xs color-light"> </i>
                    </a>
                </li>
                <li>
                    <a target="_blank" [href]="'partners_catalog_kb_link_3' | translate">
                        {{ "partners_catalog_kb_text_3" | translate }}
                        <i class="sp-icon icon-outgoing small-xs color-light"> </i>
                    </a>
                </li>
            </ul>
        </div>
    </div>

    <!-- <div class="modal-footer">
        <div class="cta-publish-modal-footer">
            <label class="checkbox-label">
                <input type="checkbox" [ngModel]="doNotShowAgain()" (ngModelChange)="onToggleCheckbox($event)" />
                {{ "cta_after_publish_modal_do_not_show_again" | translate }}
            </label>

            <button type="button" class="btn btn-success" [disabled]="!doNotShowAgain()" (click)="onConfirm()">
                {{ "cta_after_publish_modal_confirm_btn" | translate }}
            </button>
        </div>
    </div> -->
</div>
